export const whiteWine = {
    dryWhiteWine: [ 
        "assyrtiko", 
        "pinot_blanc",
        "cortese",
        "roussanne",
        "moschofilero",
        "muscadet",
        "viognier",
        "verdicchio",
        "greco",
        "marsanne",
        "white_burgundy",
        "chardonnay",
        "gruener_veltliner",
        "white_rioja",
        "frascati",
        "gavi",
        "l_acadie_blanc",
        "trebbiano",
        "sauvignon_blanc",
        "catarratto",
        "albarino",
        "arneis",
        "verdejo",
        "vermentino",
        "soave",
        "pinot_grigio",
        "dry_riesling",
        "torrontes"
    ],
    otherWhiteWine: [
        "mueller_thurgau",
        "grechetto",
        "gewurztraminer",
        "chenin_blanc",
        "white_bordeaux",
        "semillon",
        "riesling",
        "sauternes",
        "sylvaner",
        "lillet_blanc"
    ]
}

export const redWine = {
    dryRedWine: [
        "petite_sirah",
        "zweigelt",
        "baco_noir",
        "bonarda",
        "cabernet_franc",
        "bairrada",
        "barbera_wine",
        "primitivo",
        "pinot_noir",
        "nebbiolo",
        "dolcetto",
        "tannat",
        "negroamaro",
        "red_burgundy",
        "corvina",
        "rioja",
        "cotes_du_rhone",
        "grenache",
        "malbec",
        "zinfandel",
        "sangiovese",
        "carignan",
        "carmenere",
        "cesanese",
        "cabernet_sauvignon",
        "aglianico",
        "tempranillo",
        "shiraz",
        "mourvedre",
        "merlot",
        "nero_d_avola"
    ],
    otherRedWine: [
        "bordeaux",
        "marsala",
        "port",
        "gamay",
        "dornfelder",
        "concord_wine",
        "sparkling_red_wine",
        "pinotage",
        "agiorgitiko"
    ]
}

export const desertWine = {
    dWine: [
        "pedro_ximenez",
        "moscato",
        "late_harvest",
        "ice_wine",
        "white_port",
        "lambrusco_dolce",
        "madeira",
        "banyuls",
        "vin_santo",
        "port",
    ]
}

export const sparklingWine = {
    sWine: [
        "cava",
        "cremant",
        "champagne",
        "prosecco",
        "spumante",
        "sparkling_rose",
    ]
}